import { render, staticRenderFns } from "./GTS.vue?vue&type=template&id=70c26dfd&scoped=true&"
import script from "./GTS.vue?vue&type=script&lang=js&"
export * from "./GTS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c26dfd",
  null
  
)

export default component.exports